import { render, staticRenderFns } from "./orders-chart.vue?vue&type=template&id=532a3999&scoped=true&"
import script from "./orders-chart.js?vue&type=script&lang=js&"
export * from "./orders-chart.js?vue&type=script&lang=js&"
import style0 from "./orders-chart.scss?vue&type=style&index=0&id=532a3999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a3999",
  null
  
)

export default component.exports